import React from "react";

import "./Socials.scss";

const Socials = (props) => {
  const hostURL = window.location.host;
  const pathURL = window.location.pathname;

  return (
    <div className="Socials">
      <div className="Socials__text">{props.shareText}</div>
      <a
        aria-label="share page by email"
        rel="noreferrer"
        target="_blank"
        href={`mailto:?subject=Check%20out%20this%20Intelligent%20Service%20self-assessment&body=I%20just%20completed%20this%20quick%20self-assessment%20measuring%20intelligent%20service%20capabilities.%20Give%20it%20a%20try%20and%20share%20your%20results. https://${hostURL}${pathURL}`}
        className="Socials__icon Socials__icon--1"
      ></a>
      <a
        aria-label="share page to LinkedIn"
        rel="noreferrer"
        href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${hostURL}${pathURL}`}
        className="Socials__icon Socials__icon--4"
        target="_blank"
      ></a>
      <a
        aria-label="share page to Twitter"
        rel="noreferrer"
        href={`https://twitter.com/intent/tweet?url=https://${hostURL}${pathURL}&text=Discover%20The%20Path%20to%20CX%20Data%20Excellence`}
        className="Socials__icon Socials__icon--3"
        target="_blank"
      ></a>
      <a
        aria-label="share page to Facebook"
        rel="noreferrer"
        href={`https://www.facebook.com/sharer/sharer.php?u=https://${hostURL}${pathURL}`}
        target="_blank"
        className="Socials__icon Socials__icon--2"
      ></a>

      {/* <div className="Socials__icon Socials__icon--1"></div>
            <div className="Socials__icon Socials__icon--2"></div>
            <div className="Socials__icon Socials__icon--3"></div>
            <div className="Socials__icon Socials__icon--4"></div> */}
    </div>
  );
};

export default Socials;
